export const apiURL = "https://uct.labs.fhv.at/kim/api/";
//export const apiURL = "http://ou-uct3.hostingcenter.uclv.net:7071/api/";

export default apiURL
